import styled from 'styled-components/macro';

export const StyledHeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    @media ${({ theme }) => theme.breakpoints.semiTablet} {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    @media screen and (orientation:landscape) and (max-width: 1023px) {
        display: none;
    }
`;